const pageSmallSizeTable = 10;
const pageDefaultSizeTable = 12;
const normalCharactersLength = 120;
const mediumCharactersLength = 250;

const countryUSAid = 184;
const countryAustraliaId = 10;
const countryMexicoId = 110;
const countryCanadaId = 32;

export {
  pageSmallSizeTable,
  normalCharactersLength,
  mediumCharactersLength,
  pageDefaultSizeTable,
  countryUSAid,
  countryAustraliaId,
  countryMexicoId,
  countryCanadaId,
};
